import React from 'react';

const PoweredBy = () => (<div className="powered-by"><span className="taina-brand">Powered by </span><div className="logo-nameonly" /></div>);

export default PoweredBy;
